import React, { useContext, useEffect } from "react";
import "./_style.scss";
import { Box, Typography } from "@mui/material";
import { GlobalContext } from "../../../context/globalContext";
import { TkRouteContext } from "../../../context/tkRouteContext";
import { BusinessContext } from "../../../context/businessContext";

const ErrorPage = () => {
  const { setState } = useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);
  const { setState: setRouterState } = useContext(TkRouteContext);

  useEffect(() => {
    setState({});

    setBusinessState({});
  
    setRouterState({
      routerList: [],
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="tkErrorPage401">
      <h1>システムエラー</h1>
      <Typography className="errorText">
        お問い合わせフォームより機構へお問い合わせください
      </Typography>
    </Box>
  );
};

export default ErrorPage;
